export default __webpack_public_path__ + "static/media/1.ea9df303.png";